module.exports = __webpack_public_path__ + "static/media/IMG_7246.f8deb37d.JPG";